import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-primary tech-grid" data-id="element-102" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-103" data-mp="22367dpybvxqo">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-surface border-2 border-accent rounded-2xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg" data-id="element-104" data-mp="2223g3gx3fta8">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-xl bg-primary text-accent mb-8" data-id="element-105" data-mp="1j4ai8t1bu9jp">
            <ShieldCheck size={48} data-id="element-106" data-mp="1edk8l3lvbkj7" />
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold uppercase mb-6 text-primary" data-id="element-107" data-mp="1ebr5tzedlkgh">
            🛡️ 7-Day Refund Policy
          </h2>
          <div className="space-y-6 text-lg text-body max-w-2xl mx-auto" data-id="element-108" data-mp="lo4zwkhoe3qg">
            <p data-id="element-109" data-mp="ozrn88kaq9yr">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-primary" data-id="element-110" data-mp="oxp1w1u3950d">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and we will review the case according to our refund policy.
            </p>
            <p className="text-sm text-muted mt-8" data-id="element-111" data-mp="61ff8q54f64r">
              The product is delivered digitally in PDF format.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}